import React, { useEffect, useState } from "react";
import AnalyticsDataService from "../../services/analytics";
import { MonthlyBarChart } from "../../Component/Analytics/MonthlyBarChart";
import { DateRangeBarChart } from "../../Component/Analytics/DateRangeBarChart";
import { Box, Button, Text, VStack } from "@chakra-ui/react";

export const UserRegistrationRecords = () => {

  const [viewMode, setViewMode] = useState("last30Days");

  const [userMonthlyData, setUserMonthlyData] = useState<any>([]);

  const toggleViewMode = () => {
    setViewMode(viewMode === "last30Days" ? "currentmonth" : "last30Days");
  };
  const getDateFormat = (dateString: string) => {
    let date = new Date(dateString);
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let monthName = monthNames[monthIndex];
    let newDateString = day + "-" + monthName + "-" + year;
    return newDateString;
  };

  const calculateSumAfterRemovingLastN = (arr: any[], n: number) => {
    const modifiedArray = n > 0 ? arr.slice(0, -n) : arr;

    const totalSum = modifiedArray.reduce((sum, obj) => sum + obj.count, 0);

    // const average = (totalSum / modifiedArray.length).toFixed(2);

    return totalSum;
  };

  const fetchUserMonthlyData = () => {
    AnalyticsDataService.getUserMonthlyData(viewMode)
      .then((res: any) => {
        const data = res.data.map((item: any) => {
          return {
            date: getDateFormat(item.date),
            count: item.count,
            App: 0,
          };
        });
        setUserMonthlyData(data);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  useEffect(() => {
    fetchUserMonthlyData();
  }, [viewMode]);
  return (
    <>
      <Box
        bg="#e98b90"
        color="white"
        fontWeight="bold"
        textAlign="center"
        textColor="black"
        py={4}
        px={6}
      >
        {viewMode === "last30Days"
          ? "Last 30 Days Report"
          : "Current Month Report"}
      </Box>
      <Box px={6} py={6} maxW="100%" bg="gray.50">
        <Button type="button" onClick={toggleViewMode} colorScheme="teal">
          {viewMode === "last30Days" ? "Current Month" : "Last 30 Days"}
        </Button>
        <VStack align="start" spacing={0}>

          <Text fontSize="lg" fontWeight="bold" mb={3} mt={8}>
            {`Daily User Registrations (Total Users : ${calculateSumAfterRemovingLastN(
              userMonthlyData,
              0
            )})`}
          </Text>

          {userMonthlyData && (
            <div className="chart-container">
              {" "}
              <MonthlyBarChart data={userMonthlyData} />{" "}
            </div>
          )}
        </VStack>
      </Box>
    </>
  );
};
